const mix = require('./util').mix;

const PRIMARY = '364fc7';
const COLOR = {
  PRIMARY: {
    BASE: '#' + PRIMARY,
    TINT01: mix('ffffff', PRIMARY, 90),
    TINT02: mix('ffffff', PRIMARY, 80),
    TINT03: mix('ffffff', PRIMARY, 60),
    TINT04: mix('ffffff', PRIMARY, 40),
    TINT05: mix('ffffff', PRIMARY, 20),
    TINT06: mix('ffffff', PRIMARY, 10),
    SHADE01: mix('000000', PRIMARY, 10),
    SHADE02: mix('000000', PRIMARY, 20),
    SHADE03: mix('000000', PRIMARY, 30),
    SHADE04: mix('000000', PRIMARY, 40),
    SHADE05: mix('000000', PRIMARY, 50),
    SHADE06: mix('000000', PRIMARY, 60),
  },
  UI: {
    BLACK: '#000000',
    UI01: '#1f2533',
    UI02: '#4b505b',
    UI03: '#61666f',
    UI04: '#787c84',
    UI05: '#8e9198',
    UI06: '#a5a7ad',
    UI07: '#bbbdc1',
    UI08: '#d2d3d6',
    UI09: '#dddee0',
    UI10: '#e8e8ea',
    UI11: '#f3f4f4',
    UI12: '#f7f7f7',
    UI13: '#2E3138',
    WHITE: '#ffffff',
  },
  STATUS: {
    SUCCESS: '#23d89e',
    ERROR: '#fc434e',
    DEFAULT: '#d2d3d6',
    PROCESSING: '#5fc8ff',
    WARNING: '#ff8c36',
    NOTIFICATION: '#ffd035',
  },
  CHART: [
    '#20BAC2', //'#50c4ff',     //Chart Color Setting(22.05.25) - 6168f654db4f14bc7426cf94
    '#6952DB', //'#3e8df6',
    '#1E5FCB', //'#ffae4d',
    '#0EBB59', //'#698fc8',
    '#FFC14A', //'#c19dff',
    '#D7C7FE', //'#91e529',
    '#FD9C94', //'#f2dc67',
    '#5C0931', //'#96f4f6',
    '#8EDDCF', //'#d6ae8c',
    '#166440', //'#b3b8ff',
    '#B3B3B3', //'#42a3a4',
    '#7394FF', //'#8365ed',
    '#8B21A6', //'#019845',
    '#EC77F2', //'#f67b7b',
    '#F56813', //'#b3b34b',
    '#90DCE0', //'#f861ad',
    '#B4A9ED', //'#9b7597',
    '#808DAE', //'#75bb68',
    '#87DDAC', //'#7178bc',
    '#FFE0A5', //'#ec77f2',
  ],
  CHARTBG: ['#dddee0'],
  // PRODUCT: {
  //   compute: '#d97557',
  //   storage: '#2e6be6',
  //   networking: '#45b0e6',
  //   container: '#6d29cc',
  //   database: '#9c3dcc',
  //   analytics: '#93bf39',
  //   application_service: '#5757d9',
  //   ai_service: '#e6b51f',
  //   devops: '#4b5173',
  //   management: '#cc5ccc',
  //   security: '#36b37e',
  // },
};

export default {
  COLOR,
};
